import { render, staticRenderFns } from "./finance-attachments.vue?vue&type=template&id=e5815ade&"
import script from "./finance-attachments.vue?vue&type=script&lang=js&"
export * from "./finance-attachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports